module.exports = __webpack_public_path__ + "static/media/elo_logo.2d92dd7f.svg";